/* eslint-disable @typescript-eslint/no-explicit-any */

export function mapObject<T, D extends { [key: string]: T }>(
  object: D,
  callbackfn: (value: T, index: number, object: D) => T
) {
  const mapped: D = {} as any;
  Object.entries(object).forEach(([key, val], index) => ((mapped as any)[key] = callbackfn(val, index, object)));
  return mapped;
}
